import { useEffect, useState } from "react";
import { Checkbox, Input } from "antd";
import useUserStore from "../../stores/store";

export default function PosBankModalInputs({ posBankItem, updatePosBankList }) {
  const { showNotification } = useUserStore();
  const [isChecked, setIsChecked] = useState(false);
  const [bankName, setBankName] = useState("");
  const [bankDisplayName, setBankDisplayName] = useState("");

  useEffect(() => {
    setIsChecked(Boolean(posBankItem.isActive) ? posBankItem.isActive : false);
    setBankName(posBankItem.name);
    setBankDisplayName(posBankItem.displayName);
  }, [posBankItem]);

  function onHandleCheckbox(e) {
    const checked = e.target.checked;
    if (!checked) {
      setIsChecked(false);
      updatePosBankList(posBankItem.posBankId, "isActive", false);
      return;
    }
    setIsChecked(true);
    updatePosBankList(posBankItem.posBankId, "isActive", true);
  }

  function onHandleBankDisplayName(e) {
    const name = e.target.value;
    if (name.length > 100) {
      showNotification("Display name exceeds its character limit.");
      return;
    }
    setBankDisplayName(name);
    updatePosBankList(posBankItem.posBankId, "displayName", name);
  }

  return (
    <section>
      <div className="flex items-center space-x-4">
        <Checkbox
          checked={isChecked}
          style={{ height: "24px", width: "24px", transform: "scale(1.2)" }}
          onChange={onHandleCheckbox}
        />
        <div className="w-[300px] py-[5px] font-bold recipe-add-ons">
          {bankName}
        </div>
        <div className="w-[300px] h-[35px] recipe-add-ons">
          <Input type="text" value={bankDisplayName} onChange={onHandleBankDisplayName} />
        </div>
      </div>
    </section>
  );
}
